import React, { Component } from "react";
import { Link } from "react-router-dom";
import VideosService from "../../../../services/video-service";
import "./VideoHomePage.scss";

class VideoHomePage extends Component {
  constructor() {
    super();
    this.videosService = new VideosService();
    this.state = {
      videos: [],
      activeVideoId: 0,
      changeToVideo: true,
    };
  }

  componentDidMount() {
    if (this.props.keyword) {
      const data = { pageNo: 0, pageSize: 8, searchQuery: this.props.keyword };
      this.getVideosWithSearchQuery(data);
    } else {
      this.getVideos();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps != this.props) {
      if (this.props.keyword) {
        const data = { pageNo: 0, pageSize: 8, searchQuery: this.props.keyword };
        this.getVideosWithSearchQuery(data);
      } else {
        this.getVideos();
      }
    }
  }

  getVideos = () => {
    this.videosService.getVideos().then((res) => {
      const { data } = res;
      console.log(data);

      this.setState({
        videos: data,
      });
    });
  };

  getVideosWithSearchQuery = (data) => {
    this.videosService.getVideosWithSearchQuery(data).then((res) => {
      const { data } = res;

      this.setState({
        videos: data.records,
      });
    });
  };

  changeToVideo = (id) => {
    this.setState({
      activeVideoId: id,
    });
  };

  showActiveVideo = () => {
    return (
      <div className="video-box">
        <iframe
          width="400"
          height="300"
          src={"https://www.youtube.com/embed/iBjTZIkD6cs" + "?rel=0&autoplay=0"}
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    );
  };

  showVideoBanner = (video) => {
    return (
      <div className="video-link">
        <div className="image-overlay d-flex justify-content-center">
          <img loading="lazy" src={video.thumbnail} onClick={() => this.changeToVideo(video.sourceId)} />
          <div className="play-icon" onClick={() => this.changeToVideo(video.sourceId)}>
            <i className="fas fa-play"></i>
          </div>
        </div>
        <div className="video-img-title d-flex justify-content-center">
          <h5 style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }} className="border-bottom border-dark">
            {video.title}
          </h5>
        </div>
      </div>
    );
  };

  openVideo = (video) => {
    this.props.history.push({
      pathname: `/videos/${video && video.type.toLowerCase().replace(/\s/g, "-")}/${video && video.title ? video.title.toLowerCase().trim().replace("?", "").replace(/\s/g, "-") : ""}-${video.id}`,
    });
  };

  render() {
    const { activeVideoId, videos } = this.state;
    console.log(videos);

    return (
      <section className="video-homepage-main section-padding bg-lightgrey">
        <div className="container">
          <div className="video-heading mb-0 d-flex justify-content-between">
            <h2 className="mb-2 align-self-center text-primary">Browse Videos</h2>
            <Link to={"/videos"} type="button" className="adp-btn adp-btn-secondary align-self-center mt-md-0 mt-2">
              View All
            </Link>
          </div>
          <div className="row">
            {/* <div className="col-md-12 main-vid">
              {videos && videos[0] && videos[0].thumbnail && (
                <div className="vidoes" onClick={() => this.openVideo(videos[0])}>
                  <div className="video-link">
                    <div className="overlay-on-video">
                      <div className="image-overlay">
                        <img loading="lazy" src={videos[0].thumbnail} style={{ height: "100%", width: "100%", objectFit: "cover" }} />
                        <div className="play-icon">
                          <i className="fas fa-play"></i>
                        </div>
                      </div>
                      <div className="vedio-img-title">
                        <h5 className="text-overflow mt-n4 mt-sm-0">{videos[0].title}</h5>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div> */}
            <div className="col-md-12 mt-3">
              <div className="row">
                {videos &&
                  videos.slice(0, 8).map((video, i) => (
                    <div className="col-md-3 col-6 mb-2" key={i}>
                      <div className="vidoes" key={i} onClick={() => this.openVideo(video)}>
                        <div className="video-link">
                          <div className="overlay-on-video">
                            <div className="image-overlay">
                              <img loading="lazy" src={video.thumbnail} />
                              <div className="play-icon">
                                <i className="fas fa-play"></i>
                              </div>
                            </div>
                            <div className="vedio-img-title mt-2">
                              <h5 className="text-overflow mt-0">{video.title}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default VideoHomePage;
